import { apiClient } from './apiClient';

export class EmployerService {
    constructor() {
        this.BASE_URL = '/employers';
    }

    async fetchEmployers(params = {}) {
        try {
            const queryParams = new URLSearchParams();
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.limit) queryParams.append('limit', params.limit.toString());
            if (params.firstName) queryParams.append('firstName', params.firstName);
            if (params.lastName) queryParams.append('lastName', params.lastName);
            // Entity filter support for UnifiedClaimsFilter
            if (params.name) queryParams.append('name', params.name);
            if (params.contact) queryParams.append('contact', params.contact);
            const sortBy = params.sortBy || 'name';
            const sortOrder = params.sortOrder || 'asc';
            queryParams.append('sortBy', sortBy);
            queryParams.append('sortOrder', sortOrder);

            const response = await apiClient.get(this.BASE_URL, { params: queryParams });
            return response;
        } catch (error) {
            console.error('Error fetching employers:', error);
            throw error;
        }
    }

    async getEmployerById(id) {
        try {
            const response = await apiClient.get(`${this.BASE_URL}/${id}`);
            return response;
        } catch (error) {
            console.error('Error fetching employer:', error);
            throw error;
        }
    }

    async createEmployer(employerData) {
        try {
            const response = await apiClient.post(this.BASE_URL, employerData);
            return response;
        } catch (error) {
            console.error('Error creating employer:', error);
            throw error;
        }
    }

    async updateEmployer(id, employerData) {
        try {
            const response = await apiClient.patch(`${this.BASE_URL}/${id}`, employerData);
            return response;
        } catch (error) {
            console.error('Error updating employer:', error);
            throw error;
        }
    }

    async deleteEmployer(id) {
        try {
            const response = await apiClient.delete(`${this.BASE_URL}/${id}`);
            return response;
        } catch (error) {
            console.error('Error deleting employer:', error);
            throw error;
        }
    }
}

export const employerService = new EmployerService();
